const alertMsgs = {
  PaymentMsg: {
    InvalidEmail: 'Please enter valid Email Address',
    PaymentOption: 'Please select Payment Option',
  },
  Dashboard: {
    NoRecordsFound: 'No Records Found',
  },
  PaymentStatus: {
    Success: 'Payment details has been updated successfully.',
    FailedPayment: 'Payment failed.',
  },
  Login: { LoginFailed: 'Wrong user id or password. Try again.' },
  RiskQualification: {
    NotQualifiedRisks: 'Some of the Risks are not qualified.',
    SelectQuestionThree: 'Please select Yes for Question # 3 to proceed ahead ',
    SelectQuestionFour: "Please select ( 'I Agree' ) for Question # 4 to proceed ahead ",
  },
  BusinessInfo: {
    DOTNotFound: 'No matching record found.',
    DOTNotEntered: 'Please enter a valid DOT Number',
    PolicyExpirationDate: 'Policy Expiration Date cannot be before Effective Date',
    FMCSAAPIError: 'FMCSA has returned an error. Please try again or enter details manually.',
    BusinessName: 'Please add Business Name',
    OneMailingAddress: 'Please add Mailing Address',
    RetailAgency: 'Please select Retail Agency',
    AgentName: 'Please select Agent',
    UnderwriterName: 'Please select Underwriter',
    FirstNameAndLastName: 'Please add First Name and Last Name',
    InsuredType: 'Please select Insured Type',
    AgentUnlicenseState: 'Agent is not allowed in this state',
    EffectiveDate: 'Please add Policy Effective Date.',
  },
  Locations: {
    AtLeastOneLocation: 'Please add at least one location to proceed !!!',
    AtMostFiveLocation: 'At most 5 addresses are allowed !!!',
    AtLeastOneMailingAddress: 'At Least 1 Mailing Address is must !!!',
    OnlyOneMailingAddress: 'Only one mailing is allowed !!!',
    MailingAddressShouldBeInGA: 'Mailing address should be in GA state',
    DuplicateAddress: 'Duplicate Address found !!!',
    LocationSaved: 'Location Saved Successfully.',
  },
  Shared: {
    TimeOut: 'Session Timed Out !!',
    LogOut: 'You have successfully logged out from the system.',
    SomethingWentWrong: 'Ooops something went wrong !!',
    RiskIsMust: 'Atleast one vehicle is must',
    CannotHaveMoreThan100: 'Cannot have more than 100%',
    PercentageOwned: 'Percentage owned should be between 0% and 100%',
    OneOfTheRaterFailed: 'One of the rater failed',
    UWReferral: 'Your policy is submitted for underwriter referral.',
    AdditionalInsuredCoverages: 'Please add Additional Insured coverages.',
    ToDate: 'Please select to date as well.',
    SuccessRequestCoverageBound: 'Sent for E-Signature',
    FailedResendHelloSign: 'Failed Resend HelloSign.',
    FailedRequestCoverageBound: 'Ooops something went wrong while sending for Signature!!',
    NoChange: 'No Differences were found in this endorsed policy.',
    LoginNotAllowed: 'You do not have permissions to access this Application',
  },
  ActionButtons: {
    SaveFailed: 'Failed policy update',
    EmailSendSuccess: 'Email sent successfully',
    EmailSendFailed: 'Email sending failed',
  },
  ToasterMsg: {
    ReferToUW: 'This Submission is referred to Underwriter for review',
    SubmissionDeclined: 'Submission has been declined as the property has an ineligible risk.',
    SomethingWentWrong: 'Something went wrong',
    SubmissionApprovedSuccess: 'Submission has been Approved!',
  },
  ModalMsgs: {
    SubmissionApproveConfirmText: 'Are you sure? You want to approve the submission?',
    AgeGreaterThan54:
      'This program is designed for practitioners 54 and under;therefore, this risk will require a referral to the carrier. Do you want to proceed?',
    AgeGreaterThan65:
      'This program is designed for practitioners 65 and under; therefore, this risk will require a referral to the carrier. Do you want to proceed?',
    AgeGreaterThan65Endo:
      'This program is designed for practitioners 65 and under; therefore, this risk will require a referral to the carrier.',
    DeclinedUWQualification:
      "Please review the underwriting question. Based on the response, this applicant is not eligible. Click 'OK' to exit the application and return to the home page.",
  },
  Endorsement: {
    RejectEndorsement: 'Endorsement Rejected successfully.',
    OngoingEndorsement:
      'There is an ongoing endorsement for this policy. Please complete or revert the open endorsement to proceed.',
    EndorsementEffectiveGreater: 'Endorsement effective date should not be greater than policy expiration',
    PriorBindDate: 'Endorsement effective date cannot be prior to last bind transaction date.',
    EndorsementStarted: 'Endorsement Started',
    EndorsementReverted: 'Endorsement reverted successfully',
    EndorsementSubmitted: 'Endorsement is submitted for UW Approval',
    EndorsementBound: 'Endorsement bound successfully',
    DownpaymentAdjusted: 'Down payment adjusted successfully.',
    EndorsementBindSuccess: 'Policy is Endorsed successfully.',
    EndorsementBindFailure: 'Failed to Endorsed policy.',
    QuoteOfferedSuccess: 'Email for Endorsed Quote sent successfully.',
    QuoteOfferedFailed: 'Failed to send Endorsed Quote Email.',
    EndorsementDeniedForAgent: 'Endorsement cannot be initiated. Please contact your underwriter.',
    EndSummaryEffectiveDate:
      'Please select Endorsement effective date between last transaction date and Policy Expiration date.',
    RenewalEndorsementSubmitted: 'Renewal Endorsement is submitted for UW Approval',
    EndorsementApproved: 'Endorsement Approved successfully.',
  },
  Cancellation: {
    PolicyCancelled: 'Policy Cancelled Successfully',
    PolicyCancelledFailure: 'Policy Cancelled Failed',
    PolicyCancellationReverted: 'Policy Cancellation Reverted Successfully',
    PolicyCancellationRevertedFailed: 'Policy Cancellation Revert Failed',
    PolicyCancellationRejected: 'Policy Cancellation Rejected Successfully',
    PolicyCancellationRejectedFailed: 'Policy Cancellation Reject Failed',
    PolicyCancellationOnHold: 'Policy Cancellation is on hold',
    PolicyCancellationOnHoldFailed: 'Policy Cancellation on hold Failed',
    SendForInsuredSign: 'Policy sent for Insured Signature',
    SendForInsuredSignFailed: 'Policy sent for Insured Signature Failed',
    ResendForInsuredSign: 'Policy Re-sent for Insured Signature',
    ResendForInsuredSignFailed: 'Policy Re-sent for Insured Signature Failed',
    PolicyCancellationApprovalPending: 'Policy Cancellation request sent for Underwriter Approval',
    AdjustPremiumFailed: 'Adjust Premium Failed',
    IncorrectFlatCancellation: 'Flat Cancellation is not possible for a date other than Effective Date of Coverage',
    LimitExceeds: 'Cancellation is not allowed as there are already three cancellation on this policy',
    RenewalCancelled: 'Renewal Cancelled Successfully',
    RenewalCancelledFailure: 'Renewal Cancelled Failed',
    RenewalCancellationApprovalPending: 'Renewal Cancellation request sent for Underwriter Approval',
    PolicyInPendingCancellation: 'Policy status changed to Pending Cancellation',
    CancellationRescind: 'Cancellation Rescinded Successfully',
    RescindCancellationStatusChange: 'Policy status changed to Rescind Request Pending Approval',
    ActivePolicyStatusChange: 'Policy status changed to Policy In Force',
  },
  Reinstatement: {
    PolicyReinstated: 'Policy Reinstated Successfully & Agent will be notified Shortly!',
    PolicyReinstateFailure: 'Policy Reinstated Failed',
    CalculatePremiumFailure: 'Calculation Premium Failed',
    ReinstateRejected: 'Reinstate request has been Rejected',
    PolicyReinstatedReverted: 'Policy Reinstated Reverted Successfully',
    PolicyReinstatedRevertedFailed: 'Policy Cancellation Revert Failed',
    PolicyReinstateApprovalPending: 'Policy Reinstate request sent for Underwriter Approval',
    LimitExceeds: 'Reinstatement is not allowed as there are already two reinstatement on this policy',
  },
  Policy: {
    PolicyBind: 'Policy Binded Successfully & Agent will be notified Shortly!',
    ProceedToCheckout: 'Checkout Process Initiated Successfully!',
    ResendCheckoutEmail: 'Checkout Link Resent Successfully!',
    ResendAgentSignatureEmail: 'Signature Link Resent Successfully!',
  },
  NonRenew: {
    NonRenewSuccess: 'Non Renewal Success',
    NonRenewRevoked: 'Non Renewal Revoked',
  },
  Vehicles: {
    RedirectToVehicle: 'Application requires at least one vehicle to continue.',
    VehiclesWithErrors: 'Some Vehicles Have Issues Please Fix Them Before Proceeding.',
    AtleastOneVehicle: 'Please add at least one vehicle.',
    DuplicateVIN: 'VIN# already added.',
    IncorrectVehiclePrice: 'Vehicle Price is not valid.',
    TruckPriceCheck: 'Truck price should not exceed $150,000.',
    TruckTractorPriceCheck: 'Truck Tractor price should not exceed $250,000.',
    TrailerPriceCheck: 'Trailer price should not exceed $100,000.',
    VehicleAdditionSuccess: 'Vehicles have been saved successfully.',
    VehicleUpdatedSuccess: 'Vehicles are updated successfully.',
    VehicleDeleteSuccess: 'Vehicles are deleted successfully.',
    CoveragesAppliedSuccessfully: 'Coverages are applied successfully.',
    DuplicateTemplate: 'Template name already exists.',
    FarthestLocationIsMandatory: 'Please select farthest location travelled.',
    PowerUnitNTL: 'Only Power Units can have NTL coverage.',
    NotApplicableTailers: 'Selected carrier can not be applied in case of non power units.',
    CannotFindVehicleDetails: 'Cannot find the Vehicle details for the VIN',
    VINAPIError: 'We cannot fetch the details for the VIN. Please try again after sometime.',
    EnterVIN: 'Please enter the VIN number.',
    ValidVIN: 'Mismatch in Vehicle details, Please try refetching the details.',
    AnnualMileageExceeded: 'The maximum limit to Annual Mileage is 2,000,000.',
    MinimumOneTruck: 'There should be at least one Truck-Tractor for the policy to be rated.',
    AtleastOneLossPayee: 'Please add at least one Loss Payee.',
    NoCameraUnit:
      'Cameras must be installed and verified in all units within 30 days of effective date. Netradyne cameras will provide a higher credit to your premium.',
    InvalidVehicleType: 'Vehicle type is not valid for coverage',
    NoVehiclesInAPD: 'All Vehicles have been Excluded from APD. Please correct if needed. No coverage will be offered.',
    NoVehiclesInAPDEND:
      'All vehicles are excluded from APD. Please roll back this endorsement and proceed with the cancellation of APD.',
    SandAndGravelALS: 'The selected vehicle type is not allowed for Alpine Long Haul.',
    VehicleDeleted: 'Vehicle deleted successfully.',
    VehicleAdded: 'Vehicle added successfully.',
    SymbolOTCExceeded: 'Symbol OTC Exceeded for Selected Year.',
    SymbolCollExceeded: 'Symbol Coll Exceeded for Selected Year.',
    VehicleOlderThan15years:
      'Please forward photos of all sides and/or Physical Damage Inspection Statement for vehicles 15 years or older with Physical Damage coverage (does not include vehicles 25 years or older).',
    VehicleAgeWithPD:
      'Please forward photos of all sides of the vehicle for vehicles 10-15 years old with Physical Damage coverage.',
    AdditionalInterestDelete: 'Lien Holder / Additional Interest Detail Deleted Successfully.',
    AdditionalInterestSaved: 'Lien Holder / Additional Interest Detail Saved Successfully.',
    DeleteVehicle: 'Are you sure to delete the vehicle?',
    Deletevehicle: 'Need to remove that vehicle to continue with policy.',
    MaxFiveVehicle: 'Only 5 vehicles allowed on an policy.',
    VehicleUpdated: 'Vehicle updated successfully.',
    DeleteInterest: 'Are you sure you want to delete this Lien Holder / Additional Interest Detail?',
    PhysicalDamage: 'We cannot cover vehicles 16 Years or older for physical damage.',
    OtcDeductibleRemoval:
      'Please be aware that the Additional Interest will be deleted with the deletion of the Physical Damage on the vehicle.',
    OTCConfirmation: (key) => `OTC deductible will be applied as $${key} for all vehicles`,
    KiaHyundaiPD: 'Physical Damage cannot be added due to manufacturer ignition recall.',
  },
  Drivers: {
    AtleastOnePrincipalDriver: 'There must be atleast one Principal driver listed on the policy to proceed.',
    DriversWithErrors: 'Some drivers have issues, please correct them to proceed ahead.',
    AtleastOneDriver: 'Please add at least one driver to proceed ahead.',
    MoveToAccountHub: 'Risk will be submitted for further review.',
    DriverUpdatedSuccess: 'Driver is updated successfully.',
    DriverAdditionSuccess: 'Driver have been saved successfully.',
    DuplicateDrivers: 'DL# already added.',
    DriverDeleteSuccess: 'Drivers are deleted successfully.',
    InvalidHireDate: 'Hire Date is not correct. Hire Date cannot be less than 18 years from DOB.',
    ExperienceMoreThanTwo: 'Driver Experience cannot be more than 2 years.',
    InvalidExperience: 'Driver Experience is not correct.',
    InvalidName: 'Driver name is invalid.',
    AddPreviousDrivingHistory: 'Please add Prior Driving History.',
    UnableToOperateVeh: 'Unable to Operater Veh.',
    InvalidDateofHire: 'Hire Date cannot be greater than 10 days from current date.',
    ValidDate: 'Please enter valid date',
    LearnerPermit: "Driver's age under 16 must be either excluded or Learners permit on the policy",
    ShouldDriverExclude: 'Should the driver be excluded?',
    AtleastOneDriverVehicle: 'Application requires at least one driver and vehicle to continue.',
  },
  CoverageInfo: {
    TrailerInterchangeAgreement: 'Signed Trailer Interchage Agreement is needed to opt for Trailer Interchange',
    RefrigeratedDeductible: 'Please select Refrigerated Breakdown Deductible',
    RefrigeratedBreakdown: 'Please select Refrigerated Breakdown',
    DryVanDeductible: 'Please select Dry Van/Flatbed Deductible',
  },
  GeneralLiabilities: {
    operationHistory: 'Please add Operation History details.',
    lossHistory: 'Please add all Loss History details.',
    newVenture: 'Please add all New Venture details.',
  },
  General: {
    UnknownError: 'Something went wrong.',
    SaveForLater: 'Data saved for later. Redirecting to Account Dashboard.',
    LogoutFromSystem: 'You have successfully logged out from system.',
    SessionExpired: 'Your session has expired. Please try again.',
    FillMandatoryFields: 'Please fill all mandatory fields',
    MoveToAccountHub: 'Redirecting to Account Hub',
    EmailSent: 'Email sent successfully.',
    ResendEmailSent: 'Esign Email sent successfully.',
    SMSsent: 'SMS sent successfully.',
    EmailFormatNotCorrect: 'Email address is not in correct format.',
    WrongUser: 'Wrong user id or password. Try again.',
    ExitApplication: 'Do you want to exit from the Application?',
    AnswerAll: 'Please answer all questions',
    SaveInfo: 'Do you want to save Application Information?',
    SaveInfoEND: 'Do you want to save Endorsement Information?',
    SaveInfoRNW: 'Do you want to save Renewal Information?',
    CancelApp: 'Do you want to cancel Application?',
    CancelEnd: 'Are you sure you want to cancel this transaction?',
    RejectEnd: 'Do you want to reject Endorsement?',
    AlphaNumSpace: (key) => `${key} should not contain special character`,
    DriverUWMessage: 'Drivers selected will be excluded. Do you wish to continue?',
    VehicleUWMessage: 'Vehicles selected will be deleted. Do you wish to continue?',
    InEligibleSave: 'Please fill details till Policy Info page to save this policy.',
    NonOwnerPolicy: 'All your vehicles will be deleted. Do you wish to continue?',
    CannotMovetoVehicles: 'Cannot move to Vehicles, as this is a Non-owner Policy.',
    BackDated:
      'Your effective date was set for more than 3 days in the past. Effective date has been updated to today’s date. You may adjust the effective date within 3 days of today’s date once the application is opened.',
    NotQualifiedBackDated:
      'This quote does not qualify for a backdated effective date. The effective date has been changed to today’s date. Select agree if you wish to move forward with this change.',
    FillValidData: 'Please enter valid value.',
    FailedPolicy: 'Something went wrong. Please try again.',
    UploadPhotos:
      'Please forward photos of all sides for vehicles that have physical damage and Proof of Prior with a lapse of more than 15 days or no Proof of Prior.',
    InActiveUser: 'InActive User id. Please reach out to Customer Service Representative.',
    ValidationProhibited: 'Access is prohibited as GAPA product is not assigned yet. Please contact IH for assistance.',
  },
  Bind: {
    BindIssueSuccess: 'Bind and issue policy successfully',
    BindIssueFailure: 'Bind and issue policy failed',
  },
  FormalQuote: {
    EmailSuccess: 'Email for Formal Quote sent successfully.',
    EmailFailure: 'Failed to send Formal Quote Email.',
    FormalQuoteSuccess: 'Formal quote offered & Email for Quote sent successfully.',
    FormalQuoteFailure: 'Failed to offer formal quote.',
    RefreshSubmissionFailed: 'Submission refresh failed',
    RefreshSubmissionSuccess: 'Submission refreshed succcessfully',
    FailedLOB: 'Cannot approve formal quote as one of the active LOB have rating error(s).',
    FailedEndorseLOB: 'Cannot approve Endorsement Quote as one of the active LOB have rating error(s).',
    IPFSCheck: 'Total Premium is greater than the allowed IPFS limit, IPFS quote will not be generated.',
    SubmissionClosedSuccess: 'Submission Closed succcessfully',
    SubmissionClosedFailure: 'Submission closure failed.',
    SubmissionAbandonedSuccess: 'Submission Abandoned succcessfully',
    SubmissionAbandonedFailure: 'Submission Abandon failed.',
    ActivateSubmissionFailed: 'Activate submission failed.',
    ActivateSubmissionSuccess: 'Submission activated succcessfully.',
    LOBNotOffered: 'LOB Not Offered Successfully',
    NeedAtleast2LOBs: 'At least 2 LOBs are mandatory to offer.',
    APDMandatoryForGL: 'APD LOB is must to select for GL LOB',
    NeedAtleast1LOBs: 'At least 1 LOBs is require to be selected to offer Formal Quote.',
    DeclineSubmissionSuccess: 'Submission Declined succcessfully',
    DeclineSubmissionFailure: 'Submission Declined failed.',
    EndorsementPolicySuccess: 'Endorsement Quote offered successfully.',
    EndorsementPolicyFailure: 'Failed to offer Endorsement Quote.',
  },
  QuoteIndication: {
    UWAlertsMessage:
      'Due to underwriting considerations we cannot offer an indication. Please submit the application to underwriter to obtain a formal quote. In order to do so click "Request Formal Quote" below.',
  },
  Summary: {
    LOBUncheckedSuccess: 'LOB not offered successfully.',
    LOBCheckedSuccess: 'LOB offered successfully.',
    LOBUncheckedFailed: 'LOB not offered failed.',
    UploadDocuments: 'Please upload mandatory documents!',
    UploadAllDocuments: 'Please Upload All Mandatory Documents!',
    SuccessfullyUploaded: 'Documents uploaded Successfully!',
    ValidFactorValue: 'Please provide a factor value',
    ValidRenewalFactorValue: 'Please provide a renewal factor value',
  },
  ComparativeRater: {
    SomethingWentWrong: 'Something went wrong...',
    NoRateFound: 'No Quotes Found',
    MaxQuoteCompareExceed: 'Max Quote Compare Limit Exceeded...',
    QuoteReferred: 'UW Referrel Required',
    // QuoteEligible: "This Quote Is Eligible...",
    // QuoteIneligible: "This Quote Is Ineligible...",
    // IneligibleRate: "This Quote Is Ineligible...",
  },
  Reinstatement: {
    ReinstateRequested: 'Reinstatement Request - Pending UW Review',
    PolicyReinstated: 'Policy Reinstated Successfully & Agent will be notified Shortly!',
  },
};

const uwRuleReasons = {
  AgeGreaterThan54: 'The Age of the Practitioner is > 54',
  AgeGreaterThan65: 'The Age of the Practitioner is > 65',
};

/** PP age referral: legacy (>54) and CR#6 (>65) rule reasons from UW engine */
export const ppAgeReferralUwRuleReasons = [uwRuleReasons.AgeGreaterThan54, uwRuleReasons.AgeGreaterThan65];

const validationMsgs = {
  Year: {
    WeeksPerYear: 'Weeks entered should be between 1 and 52',
    ValidYear: 'Year built is not valid',
    CurrentYear: 'Year built cannot be greater than current year',
    RoofUpdateYear: 'Roof Update Year cannot be less than year built or greater than current year',
    HeatingUpdateYear: 'Heating Update Year cannot be less than year built or greater than current year',
    ElectricalUpdateYear: 'Electrical Update Year cannot be less than year built or greater than current year',
    PlumbingUpdateYear: 'Plumbing Update Year cannot be less than year built or greater than current year',
  },
  Locations: {
    SelectedState: 'Risk address located in state that is not yet available',
    DuplicateLocation: 'Duplicate Address found',
    MustHaveOneLocation: 'Must have one location',
    MustHaveOneMailingAddress: 'Must have one mailing address',
    MustHaveOnlyOneMailingAddress: 'Must have only one Mailing address',
    MustHaveOneGaragingAddress: 'Must have one Garaging address',
    MustHaveOnlyOneGaragingAddress: 'Must have only one Garaging address',
    DifferentState: 'All the addresses entered should be for the same State. It cannot be multi state.',
    MustHaveOnlyOnePrimaryGaragingAddress: 'Must have only one primary garaging address',
    IncompleteLocationAddress: 'Please add complete location address.',
  },
  LOB: {
    NonSelected: 'Please select a LOB to continue',
    NonImplemented: 'This LOB has not been implemented yet',
  },
  PolicyHolder: {
    PhoneNumber: 'Phone Number is not valid',
    Email: 'Email is not valid',
    AreaSQFT: 'Area should be greater than 0',
    validCoverageA: 'Coverage A cannot be smaller than 150k',
    validCoverageB: 'Coverage B cannot be greater than Coverage A',
    validCoverageC: 'Coverage C cannot be greater than Coverage A',
    validCoverageD: 'Coverage D cannot be greater than Coverage A',
    validLossAssessment: 'Loss Assessment should be between $1000 to $100,000',
  },
  Drivers: {
    DriversWithErrors: 'Some drivers have issues, please correct them to proceed ahead.',
    AtleastOneDriver: 'Please add at least one driver to proceed ahead.',
    MoveToAccountHub: 'Risk will be submitted for further review.',
    DriverUpdatedSuccess: 'Driver is updated successfully.',
    DriverAdditionSuccess: 'Driver have been saved successfully.',
    DuplicateDrivers: 'DL# already added.',
    DriverDeleteSuccess: 'Drivers are deleted successfully.',
    InvalidHireDate: 'Hire Date is not correct. Hire Date cannot be less than 18 years from DOB.',
    ExperienceMoreThanTwo: 'Driver Experience cannot be more than 2 years.',
    InvalidExperience: 'Driver Experience is not correct.',
    InvalidName: 'Driver name is invalid.',
    AddPreviousDrivingHistory: 'Please add Prior Driving History.',
    InvalidDateofHire: 'Hire Date cannot be greater than 10 days from current date.',
    IsMilitary: 'Please select the Military Field.',
    HadDUIDWI: 'Please select the DUI/DWI Field.',
    HadTrainingCourse: 'Please select the Training Course Field',
    MaritalStatus: 'Please select the Marital Status',
    Gender: 'Please select the gender',
    RelationToApplicant: 'Please select the relation to Applicant',
    IsUSCitizen: 'Please select US Citizenship',
    LicenseNumber: 'Please fill the License Number',
    DriverType: 'Please select the Driver Type',
    DuplicateLicenseNumber:
      'The license number entered is the same as another driver on this policy. Please enter correct license number.',
    LicenseStatus: 'Please select the License Status',
    InvalidFirstName: 'First Name should not contain number or special character.',
    InvalidMiddleName: 'Middle Name should not contain number or special character.',
    InvalidLastName: 'Last Name should not contain number or special character.',
    InvalidDOB: 'Enter valid Date of Birth.',
    FillingValidation: 'There cannot be one driver with SR22 and one with SR22A.',
    UnderAgeDOB: 'Please enter Date of Birth.',
    SSNRequired: 'Please enter Social Security Number.',
    FilingLessThanDOB: 'Filing Date cannot be older than Date of Birth.',
    InvalidLicenseNumberWRTState: 'Invalid Driver License Number Format according to the state.',
    DriverCourseCompletedDate: 'Enter valid Defensive Driver Course Completion Date.',
    CanInsureOperate:
      'Named Insured cannot be excluded unless physically or legaly unable to operate vehicle. If this true, indicate by selecting the checkbox.',
    ViolationLessThanDOB: 'Violation Date cannot be older than Date of Birth.',
    InvalidViolationDate: 'Please Enter valid Violation Date.',
    LicenseState: 'Please select Driver License State.',
    InvalidViolationType: 'Please Select Violation Type.',
    MinViolationDateValidation: 'Please only post violation within the last 84 months.',
    DefensiveDriverDate: 'Defensive Driver Course Completion Date cannot be older than 36 months.',
    CannotBeMoreCurrentDate: 'Defensive Driver Course Completion Date cannot be more than current date.',
    DriverNotEligible:
      'Risk is not eligible for coverage, due to number of violations and/or accidents. Please Exclude the driver to continue',
  },
  BusinessInfo: {
    SelectTravellingOutofState: 'Please select Will you be traveling out of your garaging state?',
    StatesOfOperation: 'Please Select States/Areas of Operation',
    AgencyName: 'Please select Retail Agency',
    AgentName: 'Please select Agent',
    UnderwriterName: 'Please select Underwriter',
    PastOwnershipChanged: 'Has there been any change in operations, ownership, or management in the past 3 years?',
    SubsidiaryInfo: 'Is the applicant a subsidiary or does the applicant have subsidiaries?',
    BusinessName: 'Business Name is not valid',
    PhoneNumber: 'Phone Number is not valid',
    Email: 'Email is not valid',
    ValidPercentageRadiusOfOperation: 'Total Percentage of Radius of Operation must add to 100%',
    AddOneRadiusOfOperation: 'Please add at least one Radius of Operation',
    RadiusOfOperationPercent: 'Radius of Operation Percentage should be between 1% to 100%',
    HowOftenPercent: 'Please enter How Often between 1% - 100%',
    ValidEffectiveDate:
      'Please select an effective date no more than 30 days into the future. Quotes are only valid for 30 days. Effective date can be modified should you request to bind.',
    ValidIncorporationDate: 'Please select valid Month/Year Business Started',
  },
  Commodities: {
    PercentageHauledValid: 'Total Percentage Hauled must add to 100%',
    SelectCommodity: 'Please select Commodity',
    DuplicateCommodity: 'Commodity should not be duplicate',
    AddOneCommodity: 'Please add at least one Commodity',
    DoNotAaddBothCommodity:
      'Sand & Gravel and All Other Dumping cannot be combined with any other commodity. If your operation has a need for both it will not be a fit for Alpine.',
    DoNotAaddBothCommodityEnd:
      'Sand & Gravel and All Other Dumping cannot be combined with any other commodity. Please correct.',
    ALPPolicyALSCommodity:
      'Sand & Gravel and All Other Dumping commodity cannot be taken on this policy. Please correct.',
  },
  RiskQualification: {
    NotEligible:
      'Based upon your response, this risk does not qualify for coverage. Please contact your underwriter to discuss.',
    NotEligibleMsg:
      'Applicant is not eligible for coverage based upon the answer. Please close message and either update response or close submission.',
    NotEligibleForAL:
      'Applicant is not eligible for Auto Liability coverage based upon the answer. Please close message and either update response or close submission.',
    NotEligibleInvalidClaims: `PLEASE NOTE: Failure to promptly notify ${process.env.NEXT_PUBLIC_CLIENT} Agency may invalidate any claims made.`,
    CoverageCondition:
      'PLEASE NOTE: Failure to comply with the Coverage Conditions will be cause for cancellation. Please be sure to review and discuss with underwriter if you have any questions.',
  },
  VehiclePage: {
    ClassificationType: 'Please Select the Classification Type.',
    VehicleType: 'Please Select the Vehicle Type.',
    VIN: 'Please enter VIN Number.',
    Year: 'Please Select Vehicle Year.',
    Make: 'Please Select Valid Make.',
    Model: 'Please Select Valid Model.',
    OwnedOrLeased: 'Please Select Vehicle Owned or Leased.',
    Use: 'Please Select Vehicle Use.',
    SizeClass: 'Please select Vehicle Size.',
    VEHPRICE: 'Please Fill the Vehicle Price.',
    AtleastOneVehicle: 'Please add at least one vehicle to proceed.',
    MaxVehicleAllowed: 'Action cannot be performed because driver to vehicle ratio is exceeding.',
    VehicleLoadCapacity: 'The load capacity of this vehicle exceeds the acceptable limits and cannot be quoted.',
    MaximumLoadCapacity: (vehicles) =>
      `You cannot proceed further as vehicle ${vehicles} has load capacity which exceeds the acceptable limits.`,
    InvalidVIN: 'Please enter valid VIN Number.',
    InvalidVehiclePrice: 'Please enter valid Vehicle Price.',
    AnnualMileageRequired: 'Please enter valid Annual Mileage.',
    VinNotCorrect: 'VIN can not be verified, please review or manually enter vehicle information.',
    RedirectToVehicle: 'Application requires at least one vehicle to continue.',
    OTCCollRequired: 'OTC/COLL is required.',
    DuplicateVIN: 'The VIN entered is the same as another vehicle on this policy. Please enter correct VIN.',
    NotMoreThan1LienHolder: 'You have already added 1 Lien Holder.',
    NotMoreThan1Additional: 'You have already added 1 Additional Interest.',
    CannotAddEntityDetails: 'Cannot add more than 2 Lien Holder / Additional Interest Details.',
    GaragingAddress: 'Please enter valid Garaging Address.',
    GaragingAddressMandatory: 'PO box address cannot be a garaging address. Please enter a valid garaging address.',
    ChangedOTC: 'All vehicles with OTC/Collision will be updated with the same deductibles.',
    ConvertedToNonOwner: 'This policy is now converted into Non-owner Policy.',
    ChangedAddress: 'Changing the address to out of state will cancel the policy.',
    EnterVIN: 'VIN number is required to proceed ahead. Please visit Vehicle screen and enter VIN details.',
  },
  Vehicles: {
    VehiclePriceGreaterThanZero: 'TIV must be between $1 and $250,000',
    VehicleVIN: 'Invalid VIN',
    SelectOverrideVIN: 'Please select Override VIN',
    VehicleType: 'Please select Vehicle Type',
    Year: 'Please select Year',
    Make: 'Please select Make',
    Model: 'Please add Model',
    ElectronicLoggingDevice: 'Please select Is there a Electronic Logging Device in the unit?',
  },
  GeneralLiabilitiesQueries: {
    EquipmentNotListed:
      'Please select Does the applicant have any owned, leased or operated equipment that is not listed on the vehicle schedule?',
    HazardousCommodities: 'Please select Does the applicant haul any hazardous commodities?',
    SafetyProgram: 'Please select Is there a safety program in place?',
    MaintenanceProgram: 'Please select Is there a maintenance program in place?',
    TrailerDetached: 'Please select Has a loaded trailer ever detached from tractor?',
    UnloadedOrUnAttended: 'Please select Are vehicles ever left unloaded and unattended?',
    DetachedFromPowerUnits: 'Please select Does applicant ever leave loaded trailers detached from power units?',
    SecurityAtLocations: 'Please select What security is provided for loaded vehicles at locations?',
    SecurityWhileTransit: 'Please select What security is provided for loaded vehicles in transit?',
    TruckersOperateUnderApplicant: 'Please select Do other truckers operate under the permit of the applicant?',
    ApplicantHaulForOthers: 'Please select Does applicant haul for other truckers?',
    HiredEquipment: 'Please select Does applicant ever use hired equipment?',
    EquipmentLoanOrRented: 'Please select Will any of your equipment ever be loaned or rented to others?',
    UseNonListedVehicles:
      'Please select Do you own or use trucks and/or trailers that are not listed in your schedule of vehicles accompanying this application?',
    EquipmentServiced: 'Please select Is equipment regularly inspected and serviced?',
    SafetyCodeViolation: 'Please select Any uncorrected fire and/or safety code violations',
    MolestationAllegations:
      'Please select Any past losses or claims relating to sexual abuse or molestation allegations, discrimination or negligent hiring?',
    IsConvictedCrime:
      'Please select During the last five years, has any applicant been indicted for or convicted or any degree of the crime of fraud, bribery, arson or any other arson-related crime in connection with this or any other property?',
    JudgementOrLien: 'Please select Has applicant had a judgement or lien during the last five years?',
    IsBusinessPlacedInTrust: 'Please select Has business been placed in a trust?',
    AnyForeignOperations:
      'Please select Any foreign operations, foreign products distributed in USA, or US Products sold / distributed in foreign countries?',
    OtherBusinessVentuers:
      'Please select Does applicant have other business ventures for which coverage is not requested',
    NonZeroValue: 'Operation value can not be zero',
    PercentOfTruckersOperateUnderPermit:
      'Percentage of truckers operate under the permit should be in the range of 1% to 100%',
  },
  NewVentureQueries: {
    AccidentInLastThreeYears: 'Please select Accident In Last Three Years Value',
    IncreaseAutosNextTwelveMonth: 'Please select Increase Autos in Next TwelveMonth value',
    UnderDifferentAuthority: 'Please select user Under Different Authority value',
    ValidLicenceDate: 'Please select valid Commercial Class A License Date',
  },
  CoveragePage: {
    EmailMissing: 'Cannot have Paperless Discount as no Email is present.',
    POPDiscount: 'There cannot be more than a 30 day lapse in coverage to receive a Proof of Prior discount.',
    POPDiscount1: 'There must be six months prior coverage to receive a Proof of Prior discount.',
    MinimumOneDriver: 'Policy should have atleast one vehicle and driver.',
    SignatureType: 'Please select signature type',
    CalculatePremium: 'Please calculate premium before proceeding.',
    CannotSelectNoCov: "Cannot select 'No Coverage'.",
    EmailPhoneMandatory:
      'You have opted for electronic signature option. Please confirm or enter below mandatory details.',
    AddBeneficiary: 'Please enter Beneficiary detail.',
    RequiredFieldMissing: 'Some of the required field data is missing.',
    PayplanNull: 'Pay plan cannot be zero.',
  },
};

export { alertMsgs, validationMsgs, uwRuleReasons };
